"use client";

import { c as _c } from "react/compiler-runtime";
import BuspartnerCompanyContact from "@/app/[lng]/(mainPages)/buspartner/_components/company-contact";
import RequestModalContent from "@/components/Util/Map/Content/RequestModalContent";
import { BusRequest, RequestType } from "@/types/busrequest";
import { getIconForTransferType } from "@/utils/Utils";
import { User } from "@/types/user";
import { useTranslation } from "@/app/i18n/client";
import Link from "next/link";
import { LocaleName } from "@/app/i18n/settings";
import { MdDirectionsBus, MdReportProblem } from "react-icons/md";
import { cn } from "@/lib/utils";
import { getLocalizedRoute } from "@/utils/localized-route";
import React from "react";
import { Button } from "@/components/ui/button";
export function BusRequestModalCard(t0) {
  const $ = _c(41);
  const {
    request,
    user,
    openLogin
  } = t0;
  const {
    t,
    i18n
  } = useTranslation();
  const t1 = request.category === "grouprequest" ? "border-grouprequest" : request.category === "emergency" ? "border-emergency" : request.category === "emptyride" ? "border-emptyride" : request.category === "vacancy" ? "border-vacancy" : "border-matchbus";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("mb-2 overflow-hidden border", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `flex w-full flex-row p-2 ${request.category}`;
  let t4;
  if ($[2] !== request.category || $[3] !== request.transferType) {
    t4 = request.category === "grouprequest" ? getIconForTransferType(request.transferType, 20) : request.category === "emergency" ? <MdReportProblem size={42} /> : <MdDirectionsBus size={42} />;
    $[2] = request.category;
    $[3] = request.transferType;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== request.category) {
    t5 = request.category.toUpperCase();
    $[5] = request.category;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = t5 as Uppercase<RequestType>;
  let t7;
  if ($[7] !== request.companyName || $[8] !== t || $[9] !== t6) {
    t7 = cn(t(`MAIN.${t6}.TEXT`), "/", request.companyName);
    $[7] = request.companyName;
    $[8] = t;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <div className="ml-2"><h2 className="my-0 text-xl font-bold text-secondary">{t7}</h2></div>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t8) {
    t9 = <div className="flex w-full flex-row items-center">{t4}{t8}</div>;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t9) {
    t10 = <div className={t3}>{t9}</div>;
    $[16] = t3;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== request) {
    t11 = <div className="lg:basis-1/2"><RequestModalContent request={request} /></div>;
    $[19] = request;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t) {
    t12 = cn(t("HOME.MODALS.CONTACT.TEXT"));
    $[21] = t;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <div className="text-base font-bold text-secondary">{t12}</div>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== i18n || $[26] !== openLogin || $[27] !== request || $[28] !== t || $[29] !== user) {
    t14 = user ? <div className=""><BuspartnerCompanyContact request={request} /></div> : <div><p className="mt-2 text-center">{t("HOME.MODALS.CONTACT.REGISTERTOCONTACT.1")}{" "}<Link href={getLocalizedRoute(i18n.language as LocaleName, "register/buspartner")}>{t("HOME.MODALS.CONTACT.REGISTERTOCONTACT.2")}</Link>{" "}{t("HOME.MODALS.CONTACT.REGISTERTOCONTACT.3")} <br /><Button className="bg-transparent p-0 text-matchbus outline-none" onClick={() => openLogin(true)}>{t("HOME.MODALS.CONTACT.REGISTERTOCONTACT.4")}</Button>{"."}</p></div>;
    $[25] = i18n;
    $[26] = openLogin;
    $[27] = request;
    $[28] = t;
    $[29] = user;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <div className="border-secondary p-1 lg:block lg:basis-1/2 lg:border-0 lg:border-l lg:border-solid">{t13}{t14}</div>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t11 || $[35] !== t15) {
    t16 = <div className="card-body-container flex flex-col p-2 lg:flex-row">{t11}{t15}</div>;
    $[34] = t11;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t10 || $[38] !== t16 || $[39] !== t2) {
    t17 = <div className={t2}>{t10}{t16}</div>;
    $[37] = t10;
    $[38] = t16;
    $[39] = t2;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
}